export default "__VITE_PUBLIC_ASSET__7948a93c__"